import $ from 'jquery'

export default {
  methods: {
    parseXML(data) {
      return $($.parseXML(data))
    },

    extractKey(data) {
      return this.parseXML(data).find('Key').text()
    },
  },
}
